module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-2.45ee2cb1.jpeg";